import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'abc-empty-page',
  standalone: false,
  templateUrl: './abc-analysis-empty-page-screen.component.html',
  styleUrl: './abc-analysis-empty-page-screen.component.scss'
})
export class AbcAnalysisEmptyPageComponent {
  constructor(private readonly _router: Router) {}

  onNewPolicyClick(): void {
    this._router.navigate(['abc-analysis/create-policy']);
  }
}
